import React, {Component} from 'react'
import {Modal, Upload} from 'antd'
import {UploadOutlined} from '@ant-design/icons'
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'
import {inject, observer} from 'mobx-react'
import {withTranslation} from 'react-i18next'

@inject('rulesManagementStore')
@observer
class ImportModal extends Component {
  formRef = React.createRef()
  state = {
    uuid: null
  }

  beforeUpload = async () => {
    const {rulesManagementStore, importData} = this.props
    const uuid = uuidv4()
    this.setState({uuid})
    const response = await rulesManagementStore.importRulesPre(importData, uuid)
    if (response.data.code === 0) {
      return true
    }
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)

    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`,
    }
  }

  onChange = (info) => {
    const {handleCancel, importCancel, handleSearch} = this.props
    if (info.file.status !== 'uploading') {}
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn).then()
      } else {
        importCancel()
        handleCancel('rulesModalVisible')
        alertMessage.success('Import Success!').then()
        handleSearch(1, 10)
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('Import Failed!').then()
    }
  }

  getImportURL = () => {
    return `${window.g.apiBaseUrl}/api/v1/rule/importRules/${this.state.uuid}`
  }

  render() {
    const {importModalVisible, importCancel, t} = this.props
    const {Dragger} = Upload

    return (
      <Modal
        title={t(`rulesManagement.import`)}
        visible={importModalVisible}
        onCancel={importCancel}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={null}
      >
        <Dragger
          accept=".xlsx"
          action={this.getImportURL}
          headers={this.getHeader()}
          style={{width: '100%', margin: '0 auto'}}
          onChange={this.onChange}
          data={{
            importDate: moment(new Date()),
          }}
          beforeUpload={this.beforeUpload}
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined style={{color: 'rgb(154,219,231)'}}/>
          </p>
          <p className="ant-upload-text">{t(`rulesManagement.dragFile`)}</p>
        </Dragger>
      </Modal>
    )
  }
}

export default withTranslation()(ImportModal)
